export default __webpack_public_path__ + "static/media/5.b76b05aa.png";